import React from "react";

const buildAvatarDataUri = (name = "Teacher") => {
  const safeName = String(name || "Teacher").trim() || "Teacher";
  const initial = safeName.charAt(0).toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
      <defs>
        <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#f97316" />
          <stop offset="100%" stop-color="#ef4444" />
        </linearGradient>
      </defs>
      <rect width="128" height="128" rx="24" fill="url(#bg)" />
      <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="48" font-weight="700" fill="white">
        ${initial}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const TutorProfileCard = ({ tutor }) => {
  const avatarFallback = buildAvatarDataUri(tutor?.name);

  return (
    <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200">
      <div className="flex gap-6">
        <img
          src={tutor.image}
          alt={tutor.name}
          className="w-36 h-36 object-cover rounded-xl"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = avatarFallback;
          }}
        />

        <div className="flex-1">
          <h1 className="text-2xl font-semibold text-gray-900">
            {tutor.name}
          </h1>

          <div className="flex items-center gap-2 mt-2">
            <span className="text-gray-700">{tutor.experience}</span>
          </div>

          <div className="flex gap-2 mt-3 flex-wrap">
            {(tutor.years || []).map((y, i) => (
              <span
                key={i}
                className="px-4 py-1 bg-gray-100 rounded-full text-sm border border-gray-300"
              >
                {y}
              </span>
            ))}
          </div>

          <div className="mt-6">
            <h2 className="font-semibold text-gray-900 text-lg">
              About
            </h2>
            <p className="text-gray-700 mt-2 leading-relaxed">
              {tutor.description || "No description provided."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorProfileCard;
